/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import applicationFieldsetTemplate from './application-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function ApplicationDirective($compile, $templateCache, $translate, toast) {
    var linker = function (scope, element) {
        var template = $templateCache.get(applicationFieldsetTemplate);
        element.html(template);

        scope.onApplicationIdCopied = function() {
            toast.showSuccess($translate.instant('application.idCopiedMessage'), 750, angular.element(element).closest(".toast-parent"), 'bottom left');
        };

        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            application: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/application/application.directive.js